import { InjectionToken, inject } from '@angular/core';

function get$injector(): angular.auto.IInjectorService {
    return inject('$injector' as any);
}

export const ThemeProvider = new InjectionToken('themeProvider', {
    factory: () => get$injector().get('themeProvider')
});

export const MdTheming = new InjectionToken('$mdTheming', {
    factory: () => get$injector().get('$mdTheming')
});

export const SensorService = new InjectionToken('sensorService', {
    factory: () => get$injector().get('sensorService')
});

export const MonitoringChartLegendOptionService = new InjectionToken('monitoringChartLegendOptionService', {
    factory: () => get$injector().get('monitoringChartLegendOptionService')
});

export const MonitoringChartService = new InjectionToken('monitoringChartService', {
    factory: () => get$injector().get('monitoringChartService')
});

export const MonitoringChartTooltipFormatterService = new InjectionToken('monitoringChartTooltipFormatterService', {
    factory: () => get$injector().get('monitoringChartTooltipFormatterService')
});

export const MonitoringChartBinaryValueOffsetService = new InjectionToken('monitoringChartBinaryValueOffsetService', {
    factory: () => get$injector().get('monitoringChartBinaryValueOffsetService')
});

export const MonitoringChartColorService = new InjectionToken('monitoringChartColorService', {
    factory: () => get$injector().get('monitoringChartColorService')
});

export const MonitoringChartLegendSortService = new InjectionToken('monitoringChartLegendSortService', {
    factory: () => get$injector().get('monitoringChartLegendSortService')
});

export const AreaSvgRegistrationService = new InjectionToken('areaSvgRegistrationService', {
    factory: () => get$injector().get('areaSvgRegistrationService')
});

export const DeviceModelService = new InjectionToken('deviceModelService', {
    factory: () => get$injector().get('deviceModelService')
});
